import * as React from "react";
import classNames from "classnames";
import { Assets, Models, Components, Services, Utils } from "@sendum/core";

import { useDispatch, useSelector } from "react-redux";
import { setAllAlarmsClear, setError, setMultiplePlaceComponent, updateAlarms } from "../store/VisibilityActions";
import { VisibilityRootState } from "../store/VisibilityStore";

import s from "./VisibilityAlarms.module.scss";
import { AnyAction } from "redux";

interface IProps {
	className?: string;
}

export const VisibilityAlarms = ({ className }: IProps): JSX.Element => {
	const dispatch = useDispatch();

	const device = useSelector((state: VisibilityRootState) => state.Visibility.device);
	useSelector((state: VisibilityRootState) => state.Visibility.device?.alarms);
	const [isOpenDialog, setIsOpenDialog] = React.useState<boolean>(false);
	const isClearAll = useSelector((state: VisibilityRootState) => state.Visibility.isClearAllAlarms);
	const [clearAllReason, setClearAllReason] = React.useState<string>("");

	const onClickCloseHandler = (event: any) => {
		!!event.preventDefault && event.preventDefault();
		dispatch(setMultiplePlaceComponent("graph") as unknown as AnyAction);
	};

	React.useEffect(() => {
	}, [device?.alarms]);


	const submitAlarm = (alarm: Models.Alarm, reason: string): Promise<void> => {
		if (device?.shipment) {
			return Services.API.WidgetsApi.submitAlarm(device.shipment.id, device.id, buildRequestData(alarm, reason))
				.then(r => {
					submitResponseHandler(r);

					return Promise.resolve();
				})
				.catch(err => {
					console.error(err);
					dispatch(setError(err) as unknown as AnyAction);

					return Promise.resolve();
				});
		}

		return Promise.resolve();
	};


	const submitReason = (alarm: Models.Alarm, reason: string): Promise<void> => {
		if (device?.shipment) {
			return Services.API.WidgetsApi.submitReason(device.shipment.id, device.id, buildRequestData(alarm, reason))
				.then(r => {
					submitResponseHandler(r);

					return Promise.resolve();
				})
				.catch(err => {
					console.error(err);
					dispatch(setError(err) as unknown as AnyAction);

					return Promise.resolve();
				});
		}

		return Promise.resolve();
	};

	const buildRequestData = (alarm: Models.Alarm, reason: string): any => ({
		sensor: alarm.sensor.replace("SHIPMENT:alarms:", "").replace("REPORT:alarms:", ""),
		original: alarm.timestamp,
		cleared: alarm.clearedTimestamp || Utils.time.current(),
		reason,
	});

	const submitResponseHandler = (r: any): void => {
		const clearedAlarm = new Models.Alarm({
			sensor: r.Sensor,
			timestamp: Number.parseInt(r.Original),
			reason: r.Reason,
			clearedBy: r.WidgetUserId || r.User,
			clearedTimestamp: Number.parseInt(r.Cleared),
		});
		if (device) {
			dispatch(updateAlarms(device.id, clearedAlarm) as unknown as AnyAction);
		}
	};

	const submitAlarmAllFunc = (reason: string) => {
		setClearAllReason(reason);
		dispatch(setAllAlarmsClear() as unknown as AnyAction);
		setIsOpenDialog(false);
	};

	const submitReasonAllFunc = (reason: string) => {
		setClearAllReason(reason);
		dispatch(setAllAlarmsClear() as unknown as AnyAction);
		setIsOpenDialog(false);
	};

	const onClickClearAll = (event: any) => {
		event.preventDefault();
		setIsOpenDialog(true);
	};

	return (
		<div className={classNames(className, s.alarms)} data-testid="shipment-alarms">
			<Components.ClearAlarmDialog isOpen={isOpenDialog}
				alarm={new Models.Alarm({
					sensor: "clearAll",
					displayName: "",
					timestamp: Date.now(),
				})}
				cancel={() => setIsOpenDialog(false)}
				submitAlarm={submitAlarmAllFunc}
				submitReason={submitReasonAllFunc} />
			<div className={s.close}>
				<img alt={"close"} src={Assets.Close} onClick={onClickCloseHandler} />
			</div>

			<div className={s.alarms__column}>

				<div className={[s.alarms__header, s.header].join(" ")}>
					<div className={s.header__row}>
						<img className={s.header__img} alt={""} src={Assets.Alarms.YellowAlarmTriangle} />
						<div className={[s.header__count_outer, device?.getActiveAlarms().length ? s.header__alarm : s.header__no_alarm].join(" ")}>
							<div className={s.header__count_inner}>
								<div className={[s.header__countText, device?.getActiveAlarms().length ? s.header__alarm : s.header__no_alarm].join(" ")}>{device?.getActiveAlarms().length}</div>
							</div>
						</div>
					</div>
				</div>

				<div className={[s.alarms__list, s.list].join(" ")}>
					<div className={s.list__column}>
						<div className={s.list__label}>
              Active Alarms:
							{!!device?.getActiveAlarms().length && (<button onClick={onClickClearAll}>Clear All</button>)}
						</div>
						{device?.getActiveAlarms().map(alarm => (
							<div className={s.list__item} key={`${alarm.sensor}${alarm.timestamp}`}>
								<Components.AlarmComponent alarm={alarm}
									submitAlarm={submitAlarm}
									submitReason={submitReason}
									displayActions={true}
									isClearAll={isClearAll}
									clearAllReason={clearAllReason} />
							</div>))}
						<div className={s.list__label}>
              Cleared Alarms:
						</div>
						{device?.getClearedAlarms().map(alarm => (
							<div className={s.list__item} key={`${alarm.sensor}${alarm.timestamp}`}>
								<Components.AlarmComponent alarm={alarm}
									submitAlarm={submitAlarm}
									submitReason={submitReason}
									displayActions={true} />
							</div>))}
					</div>
				</div>
			</div>

		</div>
	);
};
